import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ProblemSection } from "../components/sections/home/problem-section/ProblemSection";
import { ImageSection } from "../components/sections/home/image-section/ImageSection";
import { SolutionSection } from "../components/sections/home/solution-section/SocutionSection";
import { EventSection } from "../components/sections/home/event-section/EventSection";
import { SafeSection } from "../components/sections/home/safe-section/SafeSection";

export const HomeScreen = () => {
    const location = useLocation();
    
    //scroll to section if navigate to /#something
    //used for events /#events
    useEffect(() => {
        if (location.hash) {
            const id = location.hash.replace("#", "");
            document.getElementById(id)?.scrollIntoView({
                behavior: "smooth",
            });
        }
    }, [location]);

  return (
    <>
        <ImageSection />
        <ProblemSection />
        <SolutionSection />
        <SafeSection />
        <EventSection />
    </>
  );
};